module.exports = __webpack_public_path__ + "static/media/lever-logo.99deff70.png";